import PropTypes from "prop-types";
import { STYLES } from "../common";

const DataField = ({ label, data }) =>
  data && (
    <span className={STYLES.lineClamp3}>
      <span className="tw-text-gray-50">{label}: </span>
      {data}
    </span>
  );

export default DataField;

DataField.propTypes = {
  label: PropTypes.string,
  data: PropTypes.string,
};

DataField.defaultProps = {
  label: "",
  data: null,
};
